import { ReactNode } from "react";
import { ClearableInput } from "@/components/shared/ClearableInput";
import { FilterDropdown, FilterColumn } from "@/components/shared/FilterDropdown";
import { QuickFilterChips, QuickFilterOption } from "@/components/shared/QuickFilterChips";
import { cn } from "@/lib/utils";

interface SearchFilterBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  placeholder?: string;
  filterColumns?: FilterColumn[];
  activeFilters?: Record<string, string[]>;
  onFiltersChange?: (filters: Record<string, string[]>) => void;
  children?: ReactNode;
  className?: string;
  searchWidth?: string;
  quickFilters?: QuickFilterOption[];
  quickFilterValue?: string;
  quickFilterValues?: string[];
  onQuickFilterChange?: (value: string) => void;
  quickFilterLabel?: string;
  quickFilterMaxVisible?: number;
  quickFilterSearchPlaceholder?: string;
}

export function SearchFilterBar({
  search,
  onSearchChange,
  placeholder = "Search…",
  filterColumns,
  activeFilters,
  onFiltersChange,
  children,
  className,
  searchWidth = "w-64",
  quickFilters,
  quickFilterValue,
  quickFilterValues,
  onQuickFilterChange,
  quickFilterLabel,
  quickFilterMaxVisible = 4,
  quickFilterSearchPlaceholder = "Search categories…",
}: SearchFilterBarProps) {
  return (
    <div className={cn("flex items-center gap-3 flex-wrap", className)}>
      <ClearableInput
        value={search}
        onChange={onSearchChange}
        placeholder={placeholder}
        className="h-9"
        wrapperClassName={searchWidth}
      />

      {filterColumns && activeFilters && onFiltersChange && (
        <FilterDropdown
          columns={filterColumns}
          activeFilters={activeFilters}
          onFiltersChange={onFiltersChange}
        />
      )}

      {quickFilters && quickFilters.length > 0 && quickFilterValue !== undefined && onQuickFilterChange && (
        <QuickFilterChips
          options={quickFilters}
          value={quickFilterValue}
          values={quickFilterValues}
          onChange={onQuickFilterChange}
          label={quickFilterLabel}
          maxVisible={quickFilterMaxVisible}
          searchPlaceholder={quickFilterSearchPlaceholder}
        />
      )}

      {children}
    </div>
  );
}

export type { FilterColumn, QuickFilterOption };
